//loader
import definition from 'rms_definition';
import communication_definition from 'communication_definition'; //only work in test mode
global.app.sdk.rms = global.app.create_sdk(definition, true);
//only work in test mode
if (global.app.name === 'rms_ui') {
    global.app.sdk.communication = global.app.create_sdk(communication_definition);
}
